import React, { useMemo, useState } from 'react';
import { Modal, Nav } from 'react-bootstrap-5';

import ContactForm from './form/contact_form';
import { createContact } from '../../helpers/prospect_api';
import type { Contact } from 'bundles/connect/types';

const TAB_CONTACTS = 'contacts';
const TAB_COMPANIES = 'companies';

type Props = {
  show: boolean;
  defaultTab?: string;
  onPushContact: (contact: Contact) => void;
  onHide: () => void;
}

export default function CreateModal({ show, defaultTab, onPushContact, onHide }: Props) {
  const [tab, setTab] = useState(defaultTab || TAB_CONTACTS);

  const handleSaveContact = ({ contact }) => {
    createContact(contact).then((response) => {
      onPushContact(response['connect/person'] || response['connect/company']);
      onHide();
    });
  };

  const contactType = useMemo(() => {
    if (tab == TAB_CONTACTS) return 'Connect::Person';
    if (tab == TAB_COMPANIES) return 'Connect::Company';
  }, [tab]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className="border-bottom-0 flex-row" closeButton>
        <Modal.Title as="h5">New Contact</Modal.Title>
      </Modal.Header>
      <Nav activeKey={tab} variant="tabs" onSelect={eventKey => eventKey && setTab(eventKey)}>
        <Nav.Item>
          <Nav.Link className="border-start-0" eventKey={TAB_CONTACTS}>
            Contact
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey={TAB_COMPANIES}>
            Company
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <ContactForm
        type={contactType}
        onCancel={onHide}
        onSave={handleSaveContact}
      />
    </Modal>
  );
}
